const config = {
  VITE_APP_API_URL:
    localStorage.getItem("debug:apiUrl") ||
    import.meta.env.VITE_APP_API_URL ||
    "http://localhost:3001",
  GOOGLE_CLIENT_ID: import.meta.env.VITE_APP_GOOGLE_CLIENT_ID,
  VITE_APP_URL: import.meta.env.VITE_APP_URL,
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
  VITE_APP_SENTRY_DSN: import.meta.env.VITE_APP_SENTRY_DSN,
  TINYMCE_API_KEY: "wnbiomikv9voyu6ok1gvct3pfrt5o3eefyc143i0c5ifd7cf",
  VITE_APP_SENTRY_RELEASE: import.meta.env.VITE_APP_SENTRY_RELEASE || "dev",
};

// TODO: Apply the same pattern to other config consumers
export const getConfig = (key: keyof typeof config) => {
  const value = config[key];
  if (!value) {
    throw new Error(`Config value for key ${key} is not defined`);
  }
  return value;
};

export default config;
